import Swiper from 'swiper'
import { Keyboard, Navigation, Pagination } from 'swiper/modules'

import 'swiper/scss'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export function initBitrixCasesSwiper() {
  const root = document.querySelector('[data-bitrix-cases]')
  if (!root) {
    return
  }

  const swiperEl = root.querySelector('[data-bitrix-cases-swiper]')
  if (!swiperEl) {
    return
  }

  const slides = swiperEl.querySelectorAll('.swiper-slide')
  if (!slides.length) {
    return
  }

  const paginationEl = root.querySelector('[data-bitrix-cases-pagination]')
  const prevEl = root.querySelector('[data-bitrix-cases-prev]')
  const nextEl = root.querySelector('[data-bitrix-cases-next]')

  new Swiper(swiperEl, {
    modules: [Keyboard, Navigation, Pagination],
    speed: 480,
    grabCursor: true,
    watchOverflow: true,
    // несколько слайдов в ряд: autoHeight даёт артефакты
    autoHeight: false,
    spaceBetween: 18,
    slidesPerView: 1,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
        pagination: {
          enabled: true,
        },
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 24,
        pagination: {
          enabled: true,
        },
      },
    },
    pagination: paginationEl
      ? {
          el: paginationEl,
          clickable: true,
          enabled: false,
        }
      : undefined,
    navigation:
      prevEl && nextEl
        ? {
            prevEl,
            nextEl,
          }
        : undefined,
  })
}
